import * as SentryClient from '@sentry/react'
import graylogTransport from './transport'
import PropTypes from 'prop-types'
import React from 'react'

const fallback = () => (
  <div className="maha-sentry-fallback">
    <h1>Something went wrong</h1>
    <p>The error has been reported automatically.</p>
  </div>
)

class Sentry extends React.Component {

  static propTypes = {
    children: PropTypes.any
  }

  constructor(props) {
    super(props)
    if(typeof window === 'undefined') return
    if(SentryClient.isInitialized()) return
    SentryClient.init({
      dsn: 'https://placeholder@noop.localhost/1',
      transport: graylogTransport,
      sampleRate: 1.0,
      maxBreadcrumbs: 30,
      attachStacktrace: true,
      integrations: (defaults) => [
        ...defaults.filter((i) => i.name !== 'Breadcrumbs'),
        SentryClient.breadcrumbsIntegration({
          console: false,
          dom: true,
          fetch: true,
          history: true
        })
      ],
      beforeSend(event) {
        if(event.request?.query_string) {
          event.request.query_string = '[filtered]'
        }
        return event
      }
    })
  }

  render() {
    return (
      <SentryClient.ErrorBoundary fallback={ fallback }>
        { this.props.children }
      </SentryClient.ErrorBoundary>
    )
  }

}

export default Sentry
